<template>
  <div class="ui right visible vertical very wide overlay sidebar menu">
    <!-- <div style="padding: 10px">
      <div class="container">
        <h2 class="ui header">
          <i
            :class="
              this.configuration ? this.configuration.icon : '?' + ' icon'
            "
          ></i>
          <div class="content">
            <span class>
              {{
                this.$props.element && this.$props.element.ngine_configuration
                  ? this.$props.element.ngine_configuration.name
                  : "?"
              }}
            </span>
            <div class="sub header">
              {{ this.$props.element ? this.$props.element.type : "?" }}
            </div>
          </div>
        </h2>
        <component
          :is="component"
          :element="$props.element || {}"
          :project="$props.project"
          :process="$props.process"
          @cancel="cancel"
          @ok="ok"
        />
      </div>
    </div>-->
  </div>
</template>

<script>
import StartEventSidebar from "./StartEvent/StartEventSidebar";
import UserTaskSidebar from "./UserTask/UserTaskSidebar";
import TimerBoundaryEventSidebar from "./BoundaryEvent/TimerBoundaryEventSidebar";

export default {
  name: "GeneralSidebar",
  data() {
    return {
      sidebar: {},
    };
  },
  computed: {
    component() {
      return this.configuration ? this.configuration.component : null;
    },
    configuration() {
      let type = this.$props.element ? this.$props.element.type : "";
      let businessObject = this.$props.element
        ? this.$props.element.businessObject
        : {};

      if (type == "bpmn:StartEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let eventDefinition = businessObject.eventDefinitions[0];
          if (eventDefinition.$type == "bpmn:MessageEventDefinition")
            return { icon: "blue flag checkered", component: null };
          else if (eventDefinition.$type == "bpmn:TimerEventDefinition")
            return { icon: "green flag checkered", component: null };
          else if (eventDefinition.$type == "bpmn:SignalEventDefinition")
            return { icon: "yellow flag checkered", component: null };
          else if (eventDefinition.$type == "bpmn:ConditionalEventDefinition")
            return { icon: "purple flag checkered", component: null };
          else return { icon: "question mark", component: null };
        } else return { icon: "flag checkered", component: StartEventSidebar };
      } else if (type == "bpmn:EndEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let eventDefinition = businessObject.eventDefinitions[0];
          if (eventDefinition.$type == "bpmn:MessageEventDefinition")
            return { icon: "blue flag", component: null };
          else if (eventDefinition.$type == "bpmn:EscalationEventDefinition")
            return { icon: "green flag", component: null };
          else if (eventDefinition.$type == "bpmn:ErrorEventDefinition")
            return { icon: "yellow flag", component: null };
          else if (eventDefinition.$type == "bpmn:CompensateEventDefinition")
            return { icon: "purple flag", component: null };
          else if (eventDefinition.$type == "bpmn:SignalEventDefinition")
            return { icon: "olive flag", component: null };
          else if (eventDefinition.$type == "bpmn:TerminateEventDefinition")
            return { icon: "violet flag", component: null };
          else return { icon: "question mark", component: null };
        } else return { icon: "flag grey checkered", component: null };
      } else if (type == "bpmn:IntermediateThrowEvent") {
        if (
          businessObject.eventDefinitions &&
          businessObject.eventDefinitions.length > 0
        ) {
          let ed = businessObject.eventDefinitions[0];
          if (ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
          else if (ed.$type == "bpmn:EscalationEventDefinition")
            return "green flag";
          else if (ed.$type == "bpmn:SignalEventDefinition")
            return "yellow flag";
          else if (ed.$type == "bpmn:LinkEventDefinition") return "purple flag";
          else if (ed.$type == "bpmn:CompensateEventDefinition")
            return "brown flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:IntermediateCatchEvent") {
        let ed = businessObject.eventDefinitions[0];
        if (ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
        else if (ed.$type == "bpmn:TimerEventDefinition") return "green flag";
        else if (ed.$type == "bpmn:SignalEventDefinition") return "yellow flag";
        else if (ed.$type == "bpmn:LinkEventDefinition") return "purple flag";
        else if (ed.$type == "bpmn:ConditionalEventDefinition")
          return "brown flag";
        else return "project diagram";
      } else if (type == "bpmn:ExclusiveGateway") return "project diagram";
      else if (type == "bpmn:ParallelGateway") return "project diagram";
      else if (type == "bpmn:ComplexGateway") return "project diagram";
      else if (type == "bpmn:InclusiveGateway") return "project diagram";
      else if (type == "bpmn:EventBasedGateway") return "project diagram";
      else if (type == "bpmn:Task") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:SendTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:ReceiveTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "project diagram";
      } else if (type == "bpmn:UserTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return { icon: "question mark", component: null };
        } else return { icon: "user alternate", component: UserTaskSidebar };
      } else if (type == "bpmn:ManualTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:BusinessRuleTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:ServiceTask") {
        if (this.$props.element.custom_type == "AutomatonCall") {
          console.log("sdfasdf");
          return "question mark";
        } else {
          if (
            businessObject.loopCharacteristics &&
            businessObject.loopCharacteristics.$type
          ) {
            let isSequential = businessObject.loopCharacteristics.isSequential;
            let t = businessObject.loopCharacteristics.$type;
            if (t == "bpmn:MultiInstanceLoopCharacteristics") {
              if (isSequential) return "red flag";
              else return "blue flag";
            } else if (t == "bpmn:StandardLoopCharacteristics")
              return "green flag";
            else return "question mark";
          } else return "user alternate";
        }
      } else if (type == "bpmn:ScriptTask") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:CallActivity") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:SubProcess") {
        if (
          businessObject.loopCharacteristics &&
          businessObject.loopCharacteristics.$type
        ) {
          let isSequential = businessObject.loopCharacteristics.isSequential;
          let t = businessObject.loopCharacteristics.$type;
          if (t == "bpmn:MultiInstanceLoopCharacteristics") {
            if (isSequential) return "red flag";
            else return "blue flag";
          } else if (t == "bpmn:StandardLoopCharacteristics")
            return "green flag";
          else return "question mark";
        } else return "user alternate";
      } else if (type == "bpmn:AdHocSubProcess") {
        return "users alternate";
      } else if (type == "bpmn:DataObjectReference") {
        return "settings";
      } else if (type == "bpmn:DataStoreReference") {
        return "database";
      } else if (type == "bpmn:SequenceFlow") {
        return "exchange alternate";
      } else if (type == "bpmn:DataOutputAssociation") {
        return "comment alternate";
      } else if (type == "bpmn:DataInputAssociation") {
        return "comment alternate";
      } else if (type == "bpmn:BoundaryEvent") {
        let ed = businessObject.eventDefinitions[0];
        if (ed.$type == "bpmn:MessageEventDefinition") return "blue flag";
        else if (ed.$type == "bpmn:EscalationEventDefinition")
          return "green flag";
        else if (ed.$type == "bpmn:SignalEventDefinition") return "yellow flag";
        else if (ed.$type == "bpmn:ConditionalEventDefinition")
          return "purple flag";
        else if (ed.$type == "bpmn:CancelEventDefinition") return "gray flag";
        else if (ed.$type == "bpmn:ErrorEventDefinition") return "brown flag";
        else if (ed.$type == "bpmn:CompensateEventDefinition")
          return "orange flag";
        else if (ed.$type == "bpmn:TimerEventDefinition")
          return {
            icon: "clock outline",
            component: TimerBoundaryEventSidebar,
          };
        else return "comment alternate";
      } else return "question mark";
    },
  },
  props: {
    process: Object,
    element: Object,
    project: Object,
    context: Object,
  },
  mounted() {
    // let vm = this;
    // vm.sidebar = window.jQuery(vm.$el).sidebar({
    //   transition: "overlay",
    //   dimPage: false,
    //   context: vm.$props.context,
    //   onHidden: function() {
    //     // vm.$emit("destroy");
    //     // window.jQuery(vm.$el).remove();
    //   }
    // });
    // .sidebar("toggle");
  },
  methods: {
    ok(data) {
      this.$props.element.ngine_configuration = data;
      this.$emit("save_configuration", this.$props.element);
      this.sidebar.sidebar("hide");
    },
    cancel() {
      this.sidebar.sidebar("hide");
    },
  },
};
</script>
